/* eslint-disable import/no-default-export, import/no-unused-modules, import/prefer-default-export */
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
const i18n = i18next

// Import translation files
import enTranslation from './locales/en.json'
import fiTranslation from './locales/fi.json'

// Office.js language detection helper
const detectOfficeLanguage = (): string => {
  try {
    if (typeof Office !== 'undefined' && Office.context?.displayLanguage) {
      const officeLanguage = Office.context.displayLanguage.toLowerCase()

      // Map Office language codes to our supported languages
      // Handle Finnish variants first (more specific)
      if (officeLanguage.startsWith('fi') || 
          officeLanguage === 'fi-fi' || 
          officeLanguage.includes('finnish') ||
          officeLanguage === 'suomi') {
        return 'fi'
      }
      
      // Handle English variants
      if (officeLanguage.startsWith('en') || 
          officeLanguage.includes('english')) {
        return 'en'
      }
    }
  } catch (error) {
    console.warn('Could not detect Office language:', error)
  }

  // Fallback to browser language detection
  const browserLang = navigator.language.toLowerCase()
  return browserLang.startsWith('fi') ? 'fi' : 'en'
}

// Save language preference (for LanguageSwitcher)
export const saveLanguagePreference = async (language: string): Promise<void> => {
  await i18n.changeLanguage(language)
}

const resources = {
  en: {
    translation: enTranslation
  },
  fi: {
    translation: fiTranslation
  }
}

// Initialize i18n
i18n
  .use(initReactI18next)
  .init({
    resources,

    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Namespace configuration
    defaultNS: 'translation',

    // React suspense support
    react: {
      useSuspense: false // Avoid suspense issues in Office add-ins
    }
  })

// Set initial language based on Office context
const initializeLanguage = async () => {
  // Wait for Office to be ready if it exists
  if (typeof Office !== 'undefined') {
    // Wait up to 5 seconds for Office.context to be available
    let attempts = 0
    const maxAttempts = 50
    
    while (attempts < maxAttempts && !Office.context) {
      await new Promise(resolve => setTimeout(resolve, 100))
      attempts++
    }
  }
  
  const initialLanguage = detectOfficeLanguage()
  await i18n.changeLanguage(initialLanguage)
}

// Initialize language only once, after Office is ready if available
if (typeof Office === 'undefined') {
  // Office.js not available, initialize immediately
  initializeLanguage()
} else {
  // Wait for Office.js to be ready before initializing
  Office.onReady(() => {
    initializeLanguage()
  })
}

export default i18n